// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Capitals Serif Rough.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/KCWaxMuseum-Drip.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/carousel_bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/zombie_hands.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/zombie_hands_mobile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/drip_footer.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/stars_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/news_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/skull_arrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/bone_arrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Roboto:wght@300;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://unpkg.com/flickity@2/dist/flickity.min.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Capitals Serif Rough";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Museum Drip";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
  font-weight: normal;
  font-style: normal;
}
* {
  margin: 0;
  padding: 0;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
}

.slime-green {
  color: #1DB954;
  text-shadow: 0 0 5px rgba(0, 255, 30, 0.6);
}

.blood-red {
  color: #9D0208;
  text-shadow: 0 0 5px rgba(218, 0, 0, 0.6);
}

.harvest-moon-orange {
  color: #F48C06;
  text-shadow: 0 0 5px rgba(238, 158, 29, 0.6);
}

#webpack-dev-server-client-overlay {
  display: none !important;
}

html {
  font-size: 16px;
}

body {
  background-color: #F48C06;
  margin: 0;
  font-family: "Roboto", sans-serif;
}

h1 {
  font-size: 60px;
  font-family: "Bebas Neue";
}

h2.title {
  font-family: "Museum Drip";
  text-transform: uppercase;
  font-size: 100px;
  line-height: 67px;
  letter-spacing: 2px;
  color: #9D0208;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.5);
}
@media (max-width: 974px) {
  h2.title {
    font-size: 70px;
    line-height: 40px;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  }
}

@keyframes flicker {
  0% {
    opacity: 0.4;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.4));
  }
  5% {
    opacity: 0.5;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
  }
  10% {
    opacity: 0.6;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.6));
  }
  15% {
    opacity: 0.85;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.85));
  }
  25% {
    opacity: 0.5;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
  }
  30% {
    opacity: 1;
    filter: drop-shadow(0 0 20px rgb(255, 255, 255));
  }
  35% {
    opacity: 0.1;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.01));
  }
  40% {
    opacity: 0.25;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.25));
  }
  45% {
    opacity: 0.5;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
  }
  60% {
    opacity: 1;
    filter: drop-shadow(0 0 20px rgb(255, 255, 255));
  }
  70% {
    opacity: 0.85;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.85));
  }
  80% {
    opacity: 0.4;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.4));
  }
  90% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@keyframes flicker-loop {
  0% {
    opacity: 0.2;
  }
  5% {
    opacity: 0.5;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
  }
  10% {
    opacity: 0.6;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.6));
  }
  15% {
    opacity: 0.85;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.85));
  }
  25% {
    opacity: 0.5;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
  }
  30% {
    opacity: 1;
    filter: drop-shadow(0 0 20px rgb(255, 255, 255));
  }
  35% {
    opacity: 0.1;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.01));
  }
  40% {
    opacity: 0.25;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.25));
  }
  45% {
    opacity: 0.5;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
  }
  60% {
    opacity: 1;
    filter: drop-shadow(0 0 20px rgb(255, 255, 255));
  }
  70% {
    opacity: 0.85;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.85));
  }
  80% {
    opacity: 0.4;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.4));
  }
  90% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@keyframes drip {
  0% {
    filter: none;
    transform: scaleY(0);
  }
  100% {
    filter: brightness(0);
    transform: scaleY(1);
  }
}
@keyframes growAndFade {
  0% {
    opacity: 1;
    transform: scale(0);
  }
  98% {
    opacity: 1;
    transform: scale(0.98);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes grow {
  from {
    transform: scaleY(0);
  }
  to {
    transform: scaleY(1);
  }
}
@keyframes shrink {
  from {
    transform: scaleY(1);
  }
  to {
    transform: scaleY(0);
  }
}
@keyframes desaturate {
  from {
    filter: none;
  }
  to {
    filter: brightness(0);
  }
}
@keyframes topBounce {
  0%, 100% {
    top: 35px;
  }
  50% {
    top: 30px;
  }
}
@keyframes bounce {
  0%, 100% {
    bottom: 20px;
  }
  50% {
    bottom: 30px;
  }
}
@keyframes arrowBounceNext {
  0%, 100% {
    right: 0px;
  }
  50% {
    right: 10px;
  }
}
@keyframes arrowBouncePrevious {
  0%, 100% {
    left: 0px;
  }
  50% {
    left: 10px;
  }
}
@keyframes mobileBounce {
  0% {
    margin-left: 0;
  }
  50% {
    margin-left: -30vw;
  }
  100% {
    margin-left: 0;
  }
}
.app__content {
  position: relative;
  top: 0;
  width: 100%;
  text-align: center;
}

button {
  border-radius: 3px;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  display: block;
}
button a {
  color: #fff;
  text-decoration: none;
}
button.red {
  background-color: #9D0208;
  color: #fff;
  transition: 0.2s ease-out all;
}
button.red:hover {
  background-color: #6b0105;
}
button.orange {
  background-color: #F48C06;
  color: #fff;
  transition: 0.2s ease-out all;
}

.disabled {
  pointer-events: none;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 18px;
  display: inline-block;
  vertical-align: top;
}

.cookies {
  position: fixed;
  padding: 20px;
  background: rgba(0, 0, 0, 0.9);
  color: #fff;
  z-index: 3;
  width: 100vw;
  left: 0;
  bottom: 0;
  text-align: center;
  display: none;
}
.cookies__buttons {
  display: inline-block;
  margin-left: 20px;
}
@media (max-width: 974px) {
  .cookies__buttons {
    margin-top: 15px;
  }
}
.cookies__buttons button {
  display: inline-block;
  margin: 0 10px;
}
.cookies__copy {
  margin-bottom: 20px;
  margin: auto;
  display: inline-block;
  vertical-align: bottom;
  width: 100%;
  max-width: 400px;
  text-align: left;
  font-size: 14px;
  font-weight: 200;
}

.carousel {
  position: relative;
  overflow: hidden;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding-top: 90px;
  height: 100%;
  z-index: 0;
  pointer-events: none;
}
.carousel__hands {
  position: absolute;
  top: 5vw;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: top;
  filter: drop-shadow(5px -5px 10px rgba(0, 0, 0, 0.4));
  pointer-events: none;
  background-position: center;
}
@media (max-width: 974px) {
  .carousel__hands {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: 145%;
  }
}
.carousel__items {
  position: absolute;
  margin: 0 auto;
  left: 5%;
  width: 90%;
  height: 85%;
  background-color: #000;
  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.4);
}
@media (min-width: 975px) and (max-width: 1799px) {
  .carousel__items {
    width: 90%;
    height: 82%;
  }
}
@media (max-width: 974px) {
  .carousel__items {
    width: 95%;
    height: 98.5%;
    left: 2.5%;
    top: env(safe-area-inset-bottom);
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.4);
  }
}
.carousel__items .carousel__item {
  width: 100%;
  height: 100%;
  margin: auto;
}
.carousel__items .carousel__item__copy {
  position: absolute;
  z-index: 2;
  text-align: center;
  font-size: 56px;
  line-height: 52px;
  font-family: "Museum Drip", sans-serif;
  bottom: calc(13% + 40px);
  width: 80%;
  left: 50%;
  transform: translateX(-50%);
}
@media (max-width: 974px) {
  .carousel__items .carousel__item__copy {
    display: block;
    font-size: 36px;
    line-height: 32px;
    bottom: calc(17% + 10px);
  }
}
.carousel__items .carousel__item__copy a {
  color: unset;
  text-decoration: none;
  transition: 0.3s ease-out all;
  pointer-events: all;
}
.carousel__items .carousel__item__copy a:hover {
  text-decoration: underline;
}
.carousel__items .carousel__item img, .carousel__items .carousel__item video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.carousel .item-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
  opacity: 0;
}
.carousel .item-container.fadeIn {
  opacity: 1;
  transition: opacity 2s ease-out;
}
.carousel .item-container.fadeOut {
  opacity: 0;
  transition: opacity 0.3s ease-out;
}
.carousel .carousel__item {
  left: 0 !important;
  z-index: -1;
}
.carousel .arrow-container {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  text-align: center;
  bottom: -5px;
}
@media (min-width: 975px) and (max-width: 1799px) {
  .carousel .arrow-container {
    transform: scale(0.8);
    transform-origin: left;
    margin-left: -2%;
  }
}
@media (max-width: 974px) {
  .carousel .arrow-container {
    bottom: calc(env(safe-area-inset-bottom) - 5px);
    transform: scale(0.65);
    transform-origin: left;
    margin-left: -4%;
  }
}
.carousel .arrow-container .skull {
  position: absolute;
  width: 50px;
  left: -4px;
  animation: bounce 1s infinite alternate;
  animation-delay: 0.3s;
}
.carousel .arrow-container .skull img {
  position: relative;
  top: -100px;
  width: 100%;
  height: auto;
}
.carousel .arrow-container .down-arrow {
  position: relative;
  animation: bounce 1s infinite ease-in-out;
}
.carousel .arrow-container .down-arrow img {
  width: 36px;
  height: auto;
}

.cart {
  position: fixed;
  right: 0;
  height: 100vh;
  width: 25vw;
  background-color: #000;
  z-index: 3;
  padding: 40px;
  color: #FFF;
}
.cart__title {
  position: absolute;
  top: 10px;
  font-size: 44px;
}
.cart__total {
  position: absolute;
  bottom: 40px;
}
.cart__products {
  margin-top: 60px;
}
.cart__products .cart__product {
  position: relative;
  margin-top: 20px;
}
.cart__products .cart__product__details {
  font-size: 12px;
}
.cart__products .cart__product__details__title {
  font-size: 16px;
  margin-bottom: 5px;
}
.cart__products .cart__product__details__quantity .minus, .cart__products .cart__product__details__quantity .plus {
  cursor: pointer;
  font-size: 30px;
  display: inline-block;
  margin: 10px 5px;
}
.cart.active {
  display: block;
}

.footer {
  position: relative;
  width: 100%;
  padding: 10px 0 20px 0;
  background-color: #9D0208;
  color: #FFF;
  text-align: center;
  font-size: 12px;
  z-index: 2;
  transform: translateZ(100px);
}
.footer:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: cover;
  background-repeat: no-repeat;
  left: 0;
  top: -18px;
}
.footer__content {
  position: relative;
  z-index: 1;
}
.footer__email {
  margin-top: 10px;
  font-size: 20px;
  font-family: "Museum Drip", sans-serif;
  transition: 0.3s ease-out all;
}
.footer__email a {
  color: #fff;
  text-decoration: none;
}
.footer__email a:hover {
  text-decoration: underline;
}
.footer__social {
  vertical-align: middle;
  position: relative;
  left: 0;
}
.footer__social ul {
  margin: 0;
  padding: 0;
}
.footer__social li {
  list-style: none;
  display: inline-block;
  font-size: 20px;
  margin: 0 10px;
  cursor: pointer;
}
.footer__social li a {
  color: #fff;
}
.footer__legal {
  display: inline-block;
  vertical-align: middle;
  margin-top: 5px;
}
.footer__drip {
  position: absolute;
  width: 100%;
  height: 20px;
  top: -18px;
  left: 0;
  z-index: 1;
}
.footer__drip img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.nav {
  position: fixed;
  z-index: 3;
  display: inline-block;
  width: 100%;
  height: 90px;
  padding: 20px 0;
  background-color: #000;
  transition: all 0.3s ease-out;
}
.nav.intro {
  background-color: #9D0208;
  transition: 1s all ease-out;
}
.nav__cart {
  position: absolute;
  top: 30px;
  right: 20px;
  z-index: 3;
  cursor: pointer;
  color: #FFF;
  font-size: 25px;
  transition: all 0.3s ease-out;
}
.nav__cart:hover {
  color: #F48C06;
}
.nav__cart:hover .nav__cart__count {
  color: #F48C06;
}
.nav__cart__count {
  position: absolute;
  margin-top: -20px;
  margin-left: 2px;
  font-size: 20px;
  color: #FFF;
  left: 50%;
  transform: translateX(-50%);
  font-family: "Museum Drip", sans-serif;
  transition: all 0.3s ease-out;
}
.nav__cart__count.added {
  animation: bounce 1s infinite alternate;
}
@media (max-width: 974px) {
  .nav__cart {
    transform: scale(0.9);
  }
}
.nav__background {
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #000;
  transform-origin: top;
  animation-name: shrink;
  animation-duration: 0.3s;
  animation-timing-function: ease-in;
  animation-fill-mode: forwards;
  animation-delay: 0.65s;
  z-index: -1;
}
.nav__logo {
  position: relative;
  left: 20px;
  z-index: 3;
  width: 300px;
  height: auto;
  animation: 1s ease-out 1.5s forwards flicker;
  cursor: pointer;
  transition: all 0.3s ease-out;
  margin: auto;
}
@media (max-width: 974px) {
  .nav__logo {
    width: 250px;
    left: 0;
  }
}
.nav__logo.intro {
  opacity: 0.2;
}
.nav__logo__left {
  width: 100px;
  display: inline-block;
}
.nav__logo.flicker-loop {
  animation: 1s ease-out forwards flicker-loop;
}
.nav__drip {
  position: absolute;
  height: 30px;
  bottom: -28px;
  width: 100%;
  left: 0;
  z-index: 1;
  filter: brightness(0) drop-shadow(5px -5px 10px rgba(0, 0, 0, 0.8));
}
.nav__drip img {
  width: 100%;
  animation-name: grow;
  animation-duration: 3.8s;
  animation-timing-function: cubic-bezier(0.1, 0.58, 1);
  animation-fill-mode: forwards;
  transform-origin: top;
  transform: scaleY(0);
  animation-delay: 1.1s;
}
@media (max-width: 974px) {
  .nav__drip img {
    height: 100%;
    object-fit: cover;
  }
}

.shop {
  position: relative;
  display: block;
  z-index: 2;
  margin-top: -80px;
  filter: drop-shadow(10px 10px 30px rgba(0, 0, 0, 0.4));
}
@media (max-width: 974px) {
  .shop {
    margin-top: -120px;
  }
}
.shop__title {
  position: absolute;
  top: calc(-30px - 1vw);
  right: 5vw;
  transform: rotate(-1deg);
}
@media (max-width: 974px) {
  .shop__title {
    top: calc(-22px - 1vw);
  }
}
.shop__background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-color: #000;
  clip-path: polygon(0 3%, 100% 0, 100% 97%, 0 100%);
  opacity: 0.9;
}
@media (max-width: 974px) {
  .shop__background {
    clip-path: polygon(0 1%, 100% 0, 100% 99%, 0 100%);
  }
}
.shop__background:before {
  position: absolute;
  content: "";
  left: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  z-index: -1;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.4);
}
.shop__products {
  position: relative;
  max-width: 95vw;
  margin: auto;
  text-align: center;
  z-index: 1;
  padding: 100px 0;
}
.shop__products__legal {
  font-size: 12px;
  color: #999;
  position: relative;
  top: 20px;
  width: 40%;
  font-weight: 200;
  display: block;
  margin: auto;
}
.shop__products__legal a {
  color: #999;
}
.shop__products__legal a:hover {
  text-decoration: none;
}
@media (max-width: 974px) {
  .shop__products__legal {
    width: 90%;
    bottom: 40px;
  }
}
@media (max-width: 974px) {
  .shop__products {
    padding-top: 70px;
  }
}
.shop__products .product {
  position: relative;
  width: 40vw;
  max-width: 200px;
  margin: 10px;
  display: inline-block;
  vertical-align: top;
}
@media (min-width: 975px) and (max-width: 1799px) {
  .shop__products .product {
    margin: 20px 40px;
  }
}
.shop__products .product .product-details__images {
  position: relative;
  margin: 20px 0 10px 0;
}
@media (max-width: 974px) {
  .shop__products .product .product-details__images {
    margin: 0;
  }
}
.shop__products .product .product-details__images__image {
  position: relative;
  width: 100%;
  height: 200px;
  margin: 20px 0;
}
@media (max-width: 974px) {
  .shop__products .product .product-details__images__image {
    height: 160px;
  }
}
.shop__products .product .product-details__images__image:hover .enlarge {
  display: block;
}
.shop__products .product .product-details .description {
  margin-bottom: 10px;
}
.shop__products .product .product-details .enlarge {
  position: absolute;
  top: 0;
  right: 10px;
  cursor: pointer;
  z-index: 1;
  display: none;
}
.shop__products .product .product-details .enlarge a {
  color: #fff;
}
.shop__products .product h3 {
  color: #fff;
  font-weight: 400;
  font-size: 18px;
}
@media (max-width: 974px) {
  .shop__products .product h3 {
    font-size: 14px;
  }
}
.shop__products .product img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  position: absolute;
  left: 0;
  opacity: 0;
}
.shop__products .product img.active {
  opacity: 1;
}
.shop__products .product p {
  color: #fff;
  font-size: 16px;
}
.shop__products .product p.price {
  margin: 5px 0;
  font-size: 14px;
  font-weight: 300;
}
.shop__products .product p.description {
  font-weight: 200;
  font-size: 14px;
}
@media (max-width: 974px) {
  .shop__products .product p.description {
    font-size: 12px;
  }
}
.shop__products .product select {
  display: block;
  margin: auto;
  width: 50%;
  background-color: #000;
  color: #fff;
  padding: 10px;
  font-size: 14px;
  border-radius: 3px;
  border: 2px solid #333;
}
@media (max-width: 974px) {
  .shop__products .product select {
    width: 80%;
  }
}
.shop__products .product .add-to-cart {
  display: block;
  margin: 15px auto;
  width: 70%;
  font-size: 14px;
}
@media (max-width: 974px) {
  .shop__products .product .add-to-cart {
    width: 80%;
  }
}

.news {
  position: relative;
  z-index: 1;
  text-align: left;
  filter: drop-shadow(0px -2px 5px rgba(0, 0, 0, 0.4));
  margin-top: 10px;
  vertical-align: bottom;
}
.news__title {
  position: absolute;
  rotate: 2deg;
  top: 10px;
  right: 5vw;
  color: #9D0208;
  z-index: 1;
}
@media (max-width: 974px) {
  .news__title {
    top: -16px;
  }
}
.news__background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: cover;
  background-position: center;
  clip-path: polygon(0 0, 100% 8%, 100% 100%, 0 100%);
}
@media (max-width: 974px) {
  .news__background {
    clip-path: polygon(0 1%, 100% 2%, 100% 100%, 0 100%);
  }
}
.news__list {
  position: relative;
  padding: 5vw 0 12vw 0;
  outline: none;
  height: 80vh;
  overflow: hidden;
}
@media (max-width: 974px) {
  .news__list {
    height: unset;
  }
}
.news__list__item {
  position: relative;
  width: 100%;
  padding: 0 8%;
  color: #fff;
  display: inline-block;
  text-align: center;
}
@media (max-width: 974px) {
  .news__list__item {
    min-height: 60vh;
  }
}
.news__list__item:first-child {
  display: block;
}
.news__list__item__image {
  position: relative;
  display: inline-block;
  max-width: calc(50% - 20px);
  margin-right: 20px;
  vertical-align: top;
  height: 100%;
}
@media (max-width: 974px) {
  .news__list__item__image {
    width: 90%;
    margin: 0 0 20px 0;
    max-width: none;
    padding-top: 60px;
  }
}
.news__list__item__image img {
  width: 100%;
  height: 100%;
  max-height: calc(65vh - 20px);
}
.news__list__item__text {
  display: inline-block;
  width: calc(42% - 20px);
  vertical-align: top;
  margin: auto;
  text-align: left;
}
.news__list__item__text.no-image {
  width: unset;
  padding-top: 20vh;
}
.news__list__item__text h1, .news__list__item__text h2, .news__list__item__text h3, .news__list__item__text h4, .news__list__item__text h5, .news__list__item__text h6 {
  font-family: "Capitals Serif Rough";
  font-size: 30px;
  color: #fff;
}
@media (max-width: 974px) {
  .news__list__item__text h1, .news__list__item__text h2, .news__list__item__text h3, .news__list__item__text h4, .news__list__item__text h5, .news__list__item__text h6 {
    font-size: 20px;
  }
}
.news__list__item__text__date {
  font-weight: 200;
  font-size: 14px;
  margin: 0 0 20px 0 !important;
}
.news__list__item__text__title {
  font-family: "Capitals Serif Rough";
  font-size: 30px;
  margin-bottom: 20px;
}
.news__list__item__text__copy p {
  margin: 0 0 15px 0;
}
.news__list__item__text__copy a {
  color: #FFF;
  text-decoration: underline;
}
@media (max-width: 974px) {
  .news__list__item__text {
    width: 90%;
    padding-left: 0;
  }
}
.news__list .flickity-viewport {
  overflow: visible;
}
.news__list.bounce-loop .flickity-slider {
  animation: mobileBounce 1s ease-in-out forwards;
}
.news__list .flickity-button {
  position: absolute;
  background: none;
}
.news__list .flickity-button:before {
  content: "";
  position: absolute;
  width: 40px;
  height: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-size: cover;
  transform: scale(1);
  animation: topBounce 2s infinite alternate;
  margin-top: 15px;
}
.news__list .flickity-button:after {
  position: absolute;
  right: 1%;
  width: 75px;
  height: 180px;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  transform: rotate(-90deg) scale(0.35);
}
@media (max-width: 974px) {
  .news__list .flickity-button {
    display: none;
  }
}
.news__list .flickity-button svg {
  display: none;
}
.news__list .flickity-button.previous {
  left: 5px;
}
.news__list .flickity-button.previous:disabled {
  display: none;
}
.news__list .flickity-button.previous:after {
  transform: rotate(90deg) scale(0.4);
  animation: arrowBouncePrevious 1s infinite;
}
.news__list .flickity-button.next {
  right: 5px;
}
.news__list .flickity-button.next:disabled {
  display: none;
}
.news__list .flickity-button.next:before {
  right: 30px;
}
.news__list .flickity-button.next:after {
  animation: arrowBounceNext 1s infinite;
}

.videos {
  position: relative;
  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.4);
  z-index: -1;
  margin-top: 170px;
}
@media (max-width: 974px) {
  .videos {
    margin-top: 150px;
  }
}
.videos__title {
  position: absolute;
  top: -50px;
  left: 5vw;
  z-index: 1;
}
@media (max-width: 974px) {
  .videos__title {
    top: -30px;
  }
}
.videos__item {
  position: relative;
  width: 33.3333333333%;
  padding-bottom: 22%;
  display: inline-block;
  cursor: pointer;
  background-size: cover;
  margin: 0;
  vertical-align: top;
}
.videos__item:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  opacity: 0;
  left: 0;
  transition: 0.3s ease-out opacity;
}
.videos__item:hover:before {
  opacity: 1;
}
@media (max-width: 974px) {
  .videos__item {
    width: 100%;
    padding-bottom: 68%;
  }
}
.videos__item__title {
  position: absolute;
  font-size: 42px;
  color: #FFF;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  left: 50%;
  transform: translateX(-50%);
  bottom: 40px;
  z-index: 2;
}
.videos__item:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5032606793) 0%, rgba(0, 0, 0, 0.2987788866) 38%, rgba(0, 0, 0, 0) 100%);
}

.legal {
  background-color: #000;
  padding: 40px;
  color: #FFF;
  font-family: sans-serif;
  min-height: 100vh;
  font-size: 14px;
}
.legal p {
  margin: 20px 0;
}
.legal a {
  color: #FFF;
  text-decoration: underline;
}
.legal a:hover {
  color: #F48C06;
}`, "",{"version":3,"sources":["webpack://./src/styles/_global.scss","webpack://./src/styles/main.scss","webpack://./src/styles/_app.scss","webpack://./src/styles/_ui.scss","webpack://./src/styles/_carousel.scss","webpack://./src/styles/_cart.scss","webpack://./src/styles/_footer.scss","webpack://./src/styles/_nav.scss","webpack://./src/styles/_shop.scss","webpack://./src/styles/_news.scss","webpack://./src/styles/_videos.scss","webpack://./src/styles/_legal.scss"],"names":[],"mappings":"AAMA;EACE,mCAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;ACDF;ADKA;EACE,0BAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;ACHF;ADMA;EACE,SAAA;EACD,UAAA;EAEA,0BAAA;EAEA,sBAAA;ACJD;;ADOA;EACE,cAAA;EACA,0CAAA;ACJF;;ADOA;EACE,cAAA;EACA,yCAAA;ACJF;;ADOA;EACE,cAAA;EACA,4CAAA;ACJF;;AD+DA;EACE,wBAAA;AC5DF;;AD+DA;EACE,eAAA;AC5DF;;AD+DA;EACE,yBAAA;EACA,SAAA;EACA,iCAAA;AC5DF;;AD+DA;EACE,eAAA;EACA,yBAAA;AC5DF;;ADgEE;EACE,0BAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,2CAAA;AC7DJ;ADpBI;EA0EF;IAUI,eAAA;IACA,iBAAA;IACA,2CAAA;EC5DJ;AACF;;ADgEA;EACE;IACA,YAAA;IACE,sDAAA;EC7DF;ED+DD;IACC,YAAA;IACE,sDAAA;EC7DF;ED+DD;IACC,YAAA;IACE,sDAAA;EC7DF;ED+DD;IACC,aAAA;IACE,uDAAA;EC7DF;ED+DD;IACC,YAAA;IACE,sDAAA;EC7DF;ED+DD;IACC,UAAA;IACE,gDAAA;EC7DF;ED+DD;IACC,YAAA;IACE,uDAAA;EC7DF;ED+DD;IACC,aAAA;IACE,uDAAA;EC7DF;ED+DD;IACC,YAAA;IACE,sDAAA;EC7DF;ED+DD;IACC,UAAA;IACE,gDAAA;EC7DF;ED+DD;IACC,aAAA;IACE,uDAAA;EC7DF;ED+DD;IACC,YAAA;IACE,sDAAA;EC7DF;ED+DD;IACC,YAAA;EC7DA;ED+DD;IACC,UAAA;EC7DA;AACF;ADgEA;EACE;IACE,YAAA;EC9DF;EDgEA;IACA,YAAA;IACE,sDAAA;EC9DF;EDgED;IACC,YAAA;IACE,sDAAA;EC9DF;EDgED;IACC,aAAA;IACE,uDAAA;EC9DF;EDgED;IACC,YAAA;IACE,sDAAA;EC9DF;EDgED;IACC,UAAA;IACE,gDAAA;EC9DF;EDgED;IACC,YAAA;IACE,uDAAA;EC9DF;EDgED;IACC,aAAA;IACE,uDAAA;EC9DF;EDgED;IACC,YAAA;IACE,sDAAA;EC9DF;EDgED;IACC,UAAA;IACE,gDAAA;EC9DF;EDgED;IACC,aAAA;IACE,uDAAA;EC9DF;EDgED;IACC,YAAA;IACE,sDAAA;EC9DF;EDgED;IACC,YAAA;EC9DA;EDgEA;IACE,UAAA;EC9DF;AACF;ADiEA;EACE;IACE,YAAA;IACA,oBAAA;EC/DF;EDiEA;IACE,qBAAA;IACA,oBAAA;EC/DF;AACF;ADkEA;EACE;IACE,UAAA;IACA,mBAAA;EChEF;EDkEA;IACE,UAAA;IACA,sBAAA;EChEF;EDkEA;IACE,UAAA;IACA,mBAAA;EChEF;AACF;ADmEA;EACE;IACE,UAAA;ECjEF;EDmEA;IACE,UAAA;ECjEF;AACF;ADoEA;EACE;IACE,UAAA;EClEF;EDoEA;IACE,UAAA;EClEF;AACF;ADqEA;EACE;IAAO,oBAAA;EClEP;EDmEA;IAAK,oBAAA;EChEL;AACF;ADkEA;EACE;IAAO,oBAAA;EC/DP;EDgEA;IAAK,oBAAA;EC7DL;AACF;AD+DA;EACE;IAAO,YAAA;EC5DP;ED6DA;IAAK,qBAAA;EC1DL;AACF;AD4DA;EACE;IACE,SAAA;EC1DF;ED4DA;IACE,SAAA;EC1DF;AACF;AD6DA;EACE;IACE,YAAA;EC3DF;ED6DA;IACE,YAAA;EC3DF;AACF;AD8DA;EACE;IACE,UAAA;EC5DF;ED8DA;IACE,WAAA;EC5DF;AACF;AD+DA;EACE;IACE,SAAA;EC7DF;ED+DA;IACE,UAAA;EC7DF;AACF;ADgEA;EACE;IACE,cAAA;EC9DF;EDgEA;IACE,kBAAA;EC9DF;EDgEA;IACE,cAAA;EC9DF;AACF;ACpSE;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,kBAAA;ADsSJ;;AE3SA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AF8SF;AE5SE;EACE,WAAA;EACA,qBAAA;AF8SJ;AE3SE;EACE,yBAAA;EACA,WAAA;EACA,6BAAA;AF6SJ;AE3SI;EACE,yBAAA;AF6SN;AEzSE;EACE,yBAAA;EACA,WAAA;EACA,6BAAA;AF2SJ;;AEvSA;EACE,oBAAA;AF0SF;;AEvSA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EHoCA,eAAA;EGlCA,eAAA;EACA,qBAAA;EACA,mBAAA;AF0SF;;AEvSA;EACE,eAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,OAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;AF0SF;AExSE;EACE,qBAAA;EACA,iBAAA;AF0SJ;ADpTI;EGQF;IAKI,gBAAA;EF2SJ;AACF;AEzSI;EACE,qBAAA;EACA,cAAA;AF2SN;AEvSE;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AFySJ;;AGvXA;EACE,kBAAA;EACA,gBAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;AH0XF;AGxXE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yDAAA;EACA,qBAAA;EACA,4BAAA;EACA,wBAAA;EACA,qDAAA;EACA,oBAAA;EACA,2BAAA;AH0XJ;ADnWI;EInCF;IAeI,yDAAA;IACA,qBAAA;EH2XJ;AACF;AGxXE;EACE,kBAAA;EACA,cAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EJ4DF,6CAAA;AC+TF;ADtWI;EI3BF;IAUI,UAAA;IACA,WAAA;EH2XJ;AACF;ADxXI;EIfF;IAeI,UAAA;IACA,aAAA;IACA,UAAA;IACA,gCAAA;IACA,2CAAA;EH4XJ;AACF;AG1XI;EACE,WAAA;EACA,YAAA;EACA,YAAA;AH4XN;AG1XM;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,wBAAA;EACA,UAAA;EJwBN,SAAA;EAGA,2BAAA;ACqWF;ADpZI;EIYE;IAYI,cAAA;IACA,eAAA;IACA,iBAAA;IACA,wBAAA;EHgYR;AACF;AG9XQ;EACE,YAAA;EACA,qBAAA;EACA,6BAAA;EACA,mBAAA;AHgYV;AG9XU;EACE,0BAAA;AHgYZ;AG3XM;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AH6XR;AGxXE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,gBAAA;EACA,UAAA;AH0XJ;AGxXI;EACE,UAAA;EACA,+BAAA;AH0XN;AGvXI;EACE,UAAA;EACA,iCAAA;AHyXN;AGrXE;EACE,kBAAA;EACA,WAAA;AHuXJ;AGpXE;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;AHsXJ;AD5bI;EIgEF;IASI,qBAAA;IACA,sBAAA;IACA,gBAAA;EHuXJ;AACF;AD/cI;EI4EF;IAgBI,+CAAA;IACA,sBAAA;IACA,sBAAA;IACA,gBAAA;EHuXJ;AACF;AGrXI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,uCAAA;EACA,qBAAA;AHuXN;AGrXM;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AHuXR;AGpXI;EACE,kBAAA;EACA,yCAAA;AHsXN;AGpXM;EACE,WAAA;EACA,YAAA;AHsXR;;AI3hBA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;AJ8hBF;AI5hBE;EACE,kBAAA;EACA,SAAA;EACA,eAAA;AJ8hBJ;AI3hBE;EACE,kBAAA;EACA,YAAA;AJ6hBJ;AI1hBE;EACE,gBAAA;AJ4hBJ;AI1hBI;EACE,kBAAA;EACA,gBAAA;AJ4hBN;AI3hBM;EAKE,eAAA;AJyhBR;AI7hBQ;EACE,eAAA;EACA,kBAAA;AJ+hBV;AI1hBU;EACE,eAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;AJ4hBZ;AIrhBE;EACE,cAAA;AJuhBJ;;AKtkBA;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,4BAAA;ALykBF;AKvkBE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,OAAA;EACA,UAAA;ALykBJ;AKvkBE;EACE,kBAAA;EACA,UAAA;ALykBJ;AKtkBE;EACE,gBAAA;EACA,eAAA;EACA,sCAAA;EACA,6BAAA;ALwkBJ;AKvkBI;EACE,WAAA;EACA,qBAAA;ALykBN;AKvkBM;EACE,0BAAA;ALykBR;AKpkBE;EACE,sBAAA;EACA,kBAAA;EACA,OAAA;ALskBJ;AKrkBI;EACE,SAAA;EACA,UAAA;ALukBN;AKrkBI;EACE,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;ALukBN;AKrkBM;EACE,WAAA;ALukBR;AKnkBE;EACE,qBAAA;EACA,sBAAA;EACA,eAAA;ALqkBJ;AKnkBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,OAAA;EACA,UAAA;ALqkBJ;AKpkBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;ALskBN;;AMppBA;EACE,eAAA;EACA,UAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,6BAAA;ANupBF;AMrpBE;EACE,yBAAA;EACA,2BAAA;ANupBJ;AMppBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,6BAAA;ANspBJ;AMppBI;EACE,cAAA;ANspBN;AMppBM;EACE,cAAA;ANspBR;AMlpBI;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EPqDJ,SAAA;EAGA,2BAAA;EOtDI,sCAAA;EACA,6BAAA;ANupBN;AMrpBM;EACE,uCAAA;ANupBR;ADppBI;EOhCF;IAkCI,qBAAA;ENspBJ;AACF;AMnpBE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;EACA,wBAAA;EACA,kCAAA;EACA,6BAAA;EACA,sBAAA;EACA,WAAA;ANqpBJ;AMlpBE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,4CAAA;EACA,eAAA;EACA,6BAAA;EACA,YAAA;ANopBJ;ADjrBI;EOoBF;IAYI,YAAA;IACA,OAAA;ENqpBJ;AACF;AMnpBI;EACE,YAAA;ANqpBN;AMlpBI;EACE,YAAA;EACA,qBAAA;ANopBN;AMjpBI;EACE,4CAAA;ANmpBN;AM/oBE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,OAAA;EACA,UAAA;EACA,mEAAA;ANipBJ;AM/oBI;EACE,WAAA;EACA,oBAAA;EACA,wBAAA;EACA,qDAAA;EACA,6BAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;ANipBN;ADptBI;EO2DA;IAWI,YAAA;IACA,iBAAA;ENkpBN;AACF;;AOzwBA;EACE,kBAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;EACA,sDAAA;AP4wBF;ADluBI;EQ/CJ;IAQI,kBAAA;EP6wBF;AACF;AO3wBE;EACE,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,wBAAA;AP6wBJ;AD7uBI;EQpCF;IAOI,sBAAA;EP8wBJ;AACF;AO3wBE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kDAAA;EAKA,YAAA;APywBJ;AD7vBI;EQzBF;IAWI,kDAAA;EP+wBJ;AACF;AO5wBI;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,yDAAA;EACA,wBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;ERoDJ,6CAAA;AC2tBF;AO1wBE;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AP4wBJ;AO1wBI;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AP4wBN;AO1wBM;EACE,WAAA;AP4wBR;AO1wBQ;EACE,qBAAA;AP4wBV;ADtyBI;EQYA;IAmBI,UAAA;IACA,YAAA;EP2wBN;AACF;AD5yBI;EQIF;IAiCI,iBAAA;EP2wBJ;AACF;AOzwBI;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AP2wBN;AD7yBI;EQ4BA;IASI,iBAAA;EP4wBN;AACF;AOzwBQ;EACE,kBAAA;EACA,qBAAA;AP2wBV;ADl0BI;EQqDI;IAKI,SAAA;EP4wBV;AACF;AO1wBU;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;AP4wBZ;AD70BI;EQ6DM;IAOI,aAAA;EP6wBZ;AACF;AO1wBc;EACE,cAAA;AP4wBhB;AOtwBQ;EACE,mBAAA;APwwBV;AOrwBQ;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;APuwBV;AOrwBU;EACE,WAAA;APuwBZ;AOlwBM;EACE,WAAA;EACA,gBAAA;EACA,eAAA;APowBR;ADx2BI;EQiGE;IAMI,eAAA;EPqwBR;AACF;AOnwBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;APqwBR;AOpwBQ;EACE,UAAA;APswBV;AOnwBM;EACE,WAAA;EACA,eAAA;APqwBR;AOpwBQ;EACE,aAAA;EACA,eAAA;EACA,gBAAA;APswBV;AOpwBQ;EACE,gBAAA;EACA,eAAA;APswBV;ADt4BI;EQ8HI;IAKI,eAAA;EPuwBV;AACF;AOpwBM;EACE,cAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;APswBR;ADt5BI;EQuIE;IAYI,UAAA;EPuwBR;AACF;AOpwBM;EACE,cAAA;EACA,iBAAA;EACA,UAAA;EACA,eAAA;APswBR;ADj6BI;EQuJE;IAOI,UAAA;EPuwBR;AACF;;AQr9BA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,oDAAA;EACA,gBAAA;EACA,sBAAA;ARw9BF;AQt9BE;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,UAAA;ARw9BJ;ADv7BI;ESvCF;IASI,UAAA;ERy9BJ;AACF;AQt9BE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,mDAAA;ARw9BJ;ADx8BI;ES1BF;IAYI,oDAAA;ER09BJ;AACF;AQv9BE;EACE,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;ARy9BJ;ADp9BI;ESVF;IAOI,aAAA;ER29BJ;AACF;AQz9BI;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;AR29BN;ADj+BI;ESAA;IAQI,gBAAA;ER69BN;AACF;AQ39BM;EACE,cAAA;AR69BR;AQ39BM;EACE,kBAAA;EACA,qBAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AR69BR;ADj/BI;EScE;IASI,UAAA;IACA,kBAAA;IACA,eAAA;IACA,iBAAA;ER89BR;AACF;AQ79BQ;EACE,WAAA;EACA,YAAA;EACA,6BAAA;AR+9BV;AQ59BM;EACE,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AR89BR;AQ59BQ;EACE,YAAA;EAEA,iBAAA;AR69BV;AQ19BQ;EACE,mCAAA;EACA,eAAA;EACA,WAAA;AR49BV;AD9gCI;ES+CI;IAMI,eAAA;ER69BV;AACF;AQ19BQ;EACE,gBAAA;EACA,eAAA;EACA,6BAAA;AR49BV;AQz9BQ;EACE,mCAAA;EACA,eAAA;EACA,mBAAA;AR29BV;AQv9BU;EACE,kBAAA;ARy9BZ;AQt9BU;EACE,WAAA;EACA,0BAAA;ARw9BZ;ADpiCI;ESkCE;IA+CI,UAAA;IACA,eAAA;ERu9BR;AACF;AQn9BI;EACE,iBAAA;ARq9BN;AQj9BM;EACE,+CAAA;ARm9BR;AQ98BI;EACE,kBAAA;EACA,gBAAA;ARg9BN;AQ98BM;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;ARg9BR;AQ78BM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,yDAAA;EACA,qCAAA;AR+8BR;ADxkCI;ESkGA;IA2BI,aAAA;ER+8BN;AACF;AQ98BM;EACE,aAAA;ARg9BR;AQ98BM;EACE,SAAA;ARg9BR;AQ/8BQ;EACE,aAAA;ARi9BV;AQ/8BQ;EACE,mCAAA;EACA,0CAAA;ARi9BV;AQ98BM;EACE,UAAA;ARg9BR;AQ/8BQ;EACE,aAAA;ARi9BV;AQ/8BQ;EACE,WAAA;ARi9BV;AQ/8BQ;EACE,sCAAA;ARi9BV;;ASrpCA;EACE,kBAAA;EViGA,6CAAA;EU/FA,WAAA;EAQA,iBAAA;ATipCF;AD7mCI;EU/CJ;IAcI,iBAAA;ETkpCF;AACF;AShpCE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;ATkpCJ;ADxnCI;EU9BF;IAOI,UAAA;ETmpCJ;AACF;ASjpCE;EACE,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EVyCF,eAAA;EUvCE,sBAAA;EACA,SAAA;EACA,mBAAA;ATmpCJ;ASjpCI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,UAAA;EACA,OAAA;EACA,iCAAA;ATmpCN;AS/oCM;EACE,UAAA;ATipCR;ADppCI;EUpBF;IA4BI,WAAA;IACA,mBAAA;ETgpCJ;AACF;AS9oCI;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,uCAAA;EV4BJ,SAAA;EAGA,2BAAA;EU7BI,YAAA;EACA,UAAA;ATmpCN;AShpCI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,yHAAA;ATkpCN;;AU9tCA;EACE,sBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;AViuCF;AU/tCE;EACE,cAAA;AViuCJ;AU9tCE;EACE,WAAA;EACA,0BAAA;AVguCJ;AU9tCI;EACE,cAAA;AVguCN","sourcesContent":["@import \"theme\";\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;500;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Roboto:wght@300;500;700&display=swap');\n@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');\n@import url('https://unpkg.com/flickity@2/dist/flickity.min.css');\n\n@font-face {\n  font-family: 'Capitals Serif Rough';\n  src: url('../fonts/Capitals Serif Rough.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n\n}\n\n@font-face {\n  font-family: 'Museum Drip';\n  src: url('../fonts/KCWaxMuseum-Drip.otf') format('opentype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n* {\n  margin:0;\n\tpadding:0;\n\t-moz-box-sizing:border-box;\n\t-ms-box-sizing:border-box;\n\t-webkit-box-sizing:border-box;\n\tbox-sizing:border-box;\n}\n\n.slime-green {\n  color: map-get($theme, slime-green);\n  text-shadow: 0 0 5px rgba(0, 255, 30, 0.6);\n}\n\n.blood-red {\n  color: map-get($theme, red);\n  text-shadow: 0 0 5px rgba(218, 0, 0, 0.6);\n}\n\n.harvest-moon-orange {\n  color: map-get($theme, orange);\n  text-shadow: 0 0 5px rgb(238, 158, 29, 0.6);\n}\n\n@mixin for-size($size) {\n  @if $size==phone-only {\n    @media (max-width: 974px) {\n      @content;\n    }\n  }\n\n  @else if $size==phone-up {\n    @media (min-width: 975px) {\n      @content;\n    }\n  }\n\n  @else if $size==small-desktop {\n    @media (min-width: 975px) and (max-width: 1799px) {\n      @content;\n    }\n  }\n\n  @else if $size==big-desktop-up {\n    @media (min-width: 1800px) {\n      @content;\n    }\n  }\n}\n\n@mixin button {\n  cursor: pointer;\n}\n\n@mixin centerCenter {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n\n@mixin vertCenter {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n@mixin horzCenter {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n\n@mixin boxShadow {\n  box-shadow: 10px 10px 30px rgba(0,0,0,0.4);\n}\n\n#webpack-dev-server-client-overlay {\n  display: none !important;\n}\n\nhtml {\n  font-size: 16px;\n}\n\nbody {\n  background-color: map-get($theme, orange);\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n}\n\nh1 {\n  font-size: 60px;\n  font-family: 'Bebas Neue';\n}\n\nh2 {\n  &.title {\n    font-family: 'Museum Drip';\n    text-transform: uppercase;\n    font-size: 100px;\n    line-height: 67px;\n    letter-spacing: 2px;\n    color: map-get($theme, red);\n    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.5);\n\n    @include for-size(phone-only) {\n      font-size: 70px;\n      line-height: 40px;\n      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);\n    }\n  }\n}\n\n@keyframes flicker {\n  0% {\n\t\topacity: 0.4;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .4));\n\t}\n\t5% {\n\t\topacity: 0.5;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .5));\n\t}\n\t10% {\n\t\topacity: 0.6;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .6));\n\t}\n\t15% {\n\t\topacity: 0.85;\n    filter: drop-shadow(0 0 20px rgb(255,255,255,.85));\n\t}\n\t25% {\n\t\topacity: 0.5;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .5));\n\t}\n\t30% {\n\t\topacity: 1;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, 1));\n\t}\n\t35% {\n\t\topacity: 0.1;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .01));\n\t}\n\t40% {\n\t\topacity: 0.25;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .25));\n\t}\n\t45% {\n\t\topacity: 0.5;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .5));\n\t}\n\t60% {\n\t\topacity: 1;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, 1));\n\t}\n\t70% {\n\t\topacity: 0.85;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .85));\n\t}\n\t80% {\n\t\topacity: 0.4;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .4));\n\t}\n\t90% {\n\t\topacity: 0.5;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes flicker-loop {\n  0% {\n    opacity: 0.2;\n  }\n  5% {\n\t\topacity: 0.5;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .5));\n\t}\n\t10% {\n\t\topacity: 0.6;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .6));\n\t}\n\t15% {\n\t\topacity: 0.85;\n    filter: drop-shadow(0 0 20px rgb(255,255,255,.85));\n\t}\n\t25% {\n\t\topacity: 0.5;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .5));\n\t}\n\t30% {\n\t\topacity: 1;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, 1));\n\t}\n\t35% {\n\t\topacity: 0.1;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .01));\n\t}\n\t40% {\n\t\topacity: 0.25;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .25));\n\t}\n\t45% {\n\t\topacity: 0.5;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .5));\n\t}\n\t60% {\n\t\topacity: 1;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, 1));\n\t}\n\t70% {\n\t\topacity: 0.85;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .85));\n\t}\n\t80% {\n\t\topacity: 0.4;\n    filter: drop-shadow(0 0 20px rgb(255,255,255, .4));\n\t}\n\t90% {\n\t\topacity: 0.5;\n\t}\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes drip {\n  0% { \n    filter: none;\n    transform: scaleY(0);\n  }\n  100% {\n    filter: brightness(0);\n    transform: scaleY(1);\n  }\n}\n\n@keyframes growAndFade {\n  0% {\n    opacity: 1;\n    transform: scale(0);\n  }\n  98% {\n    opacity: 1;\n    transform: scale(0.98);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1);\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes grow {\n  from { transform: scaleY(0); }\n  to { transform: scaleY(1); }\n}\n\n@keyframes shrink {\n  from { transform: scaleY(1); }\n  to { transform: scaleY(0); }\n}\n\n@keyframes desaturate {\n  from { filter: none; }\n  to { filter: brightness(0) }\n}\n\n@keyframes topBounce {\n  0%, 100% {\n    top: 35px;\n  }\n  50% {\n    top: 30px;\n  }\n}\n\n@keyframes bounce {\n  0%, 100% {\n    bottom: 20px;\n  }\n  50% {\n    bottom: 30px;\n  }\n}\n\n@keyframes arrowBounceNext {\n  0%, 100% {\n    right: 0px;\n  }\n  50% {\n    right: 10px;\n  }\n}\n\n@keyframes arrowBouncePrevious {\n  0%, 100% {\n    left: 0px;\n  }\n  50% {\n    left: 10px;\n  }\n}\n\n@keyframes mobileBounce {\n  0% {\n    margin-left: 0;\n  }\n  50% {\n    margin-left: -30vw;\n  }\n  100% {\n    margin-left: 0;\n  }\n}\n\n@function calculate-width($num-children) {\n  @if $num-children == 1 {\n    @return 100%;\n  } @else if $num-children == 2 {\n    @return 50%;\n  } @else {\n    @return null; // Add any fallback behavior if needed\n  }\n}","@import url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@300;500;700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Roboto:wght@300;500;700&display=swap\");\n@import url(\"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css\");\n@import url(\"https://unpkg.com/flickity@2/dist/flickity.min.css\");\n@font-face {\n  font-family: \"Capitals Serif Rough\";\n  src: url(\"../fonts/Capitals Serif Rough.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Museum Drip\";\n  src: url(\"../fonts/KCWaxMuseum-Drip.otf\") format(\"opentype\");\n  font-weight: normal;\n  font-style: normal;\n}\n* {\n  margin: 0;\n  padding: 0;\n  -moz-box-sizing: border-box;\n  -ms-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.slime-green {\n  color: #1DB954;\n  text-shadow: 0 0 5px rgba(0, 255, 30, 0.6);\n}\n\n.blood-red {\n  color: #9D0208;\n  text-shadow: 0 0 5px rgba(218, 0, 0, 0.6);\n}\n\n.harvest-moon-orange {\n  color: #F48C06;\n  text-shadow: 0 0 5px rgba(238, 158, 29, 0.6);\n}\n\n#webpack-dev-server-client-overlay {\n  display: none !important;\n}\n\nhtml {\n  font-size: 16px;\n}\n\nbody {\n  background-color: #F48C06;\n  margin: 0;\n  font-family: \"Roboto\", sans-serif;\n}\n\nh1 {\n  font-size: 60px;\n  font-family: \"Bebas Neue\";\n}\n\nh2.title {\n  font-family: \"Museum Drip\";\n  text-transform: uppercase;\n  font-size: 100px;\n  line-height: 67px;\n  letter-spacing: 2px;\n  color: #9D0208;\n  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.5);\n}\n@media (max-width: 974px) {\n  h2.title {\n    font-size: 70px;\n    line-height: 40px;\n    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);\n  }\n}\n\n@keyframes flicker {\n  0% {\n    opacity: 0.4;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.4));\n  }\n  5% {\n    opacity: 0.5;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));\n  }\n  10% {\n    opacity: 0.6;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.6));\n  }\n  15% {\n    opacity: 0.85;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.85));\n  }\n  25% {\n    opacity: 0.5;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));\n  }\n  30% {\n    opacity: 1;\n    filter: drop-shadow(0 0 20px rgb(255, 255, 255));\n  }\n  35% {\n    opacity: 0.1;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.01));\n  }\n  40% {\n    opacity: 0.25;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.25));\n  }\n  45% {\n    opacity: 0.5;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));\n  }\n  60% {\n    opacity: 1;\n    filter: drop-shadow(0 0 20px rgb(255, 255, 255));\n  }\n  70% {\n    opacity: 0.85;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.85));\n  }\n  80% {\n    opacity: 0.4;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.4));\n  }\n  90% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes flicker-loop {\n  0% {\n    opacity: 0.2;\n  }\n  5% {\n    opacity: 0.5;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));\n  }\n  10% {\n    opacity: 0.6;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.6));\n  }\n  15% {\n    opacity: 0.85;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.85));\n  }\n  25% {\n    opacity: 0.5;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));\n  }\n  30% {\n    opacity: 1;\n    filter: drop-shadow(0 0 20px rgb(255, 255, 255));\n  }\n  35% {\n    opacity: 0.1;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.01));\n  }\n  40% {\n    opacity: 0.25;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.25));\n  }\n  45% {\n    opacity: 0.5;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));\n  }\n  60% {\n    opacity: 1;\n    filter: drop-shadow(0 0 20px rgb(255, 255, 255));\n  }\n  70% {\n    opacity: 0.85;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.85));\n  }\n  80% {\n    opacity: 0.4;\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.4));\n  }\n  90% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes drip {\n  0% {\n    filter: none;\n    transform: scaleY(0);\n  }\n  100% {\n    filter: brightness(0);\n    transform: scaleY(1);\n  }\n}\n@keyframes growAndFade {\n  0% {\n    opacity: 1;\n    transform: scale(0);\n  }\n  98% {\n    opacity: 1;\n    transform: scale(0.98);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1);\n  }\n}\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes grow {\n  from {\n    transform: scaleY(0);\n  }\n  to {\n    transform: scaleY(1);\n  }\n}\n@keyframes shrink {\n  from {\n    transform: scaleY(1);\n  }\n  to {\n    transform: scaleY(0);\n  }\n}\n@keyframes desaturate {\n  from {\n    filter: none;\n  }\n  to {\n    filter: brightness(0);\n  }\n}\n@keyframes topBounce {\n  0%, 100% {\n    top: 35px;\n  }\n  50% {\n    top: 30px;\n  }\n}\n@keyframes bounce {\n  0%, 100% {\n    bottom: 20px;\n  }\n  50% {\n    bottom: 30px;\n  }\n}\n@keyframes arrowBounceNext {\n  0%, 100% {\n    right: 0px;\n  }\n  50% {\n    right: 10px;\n  }\n}\n@keyframes arrowBouncePrevious {\n  0%, 100% {\n    left: 0px;\n  }\n  50% {\n    left: 10px;\n  }\n}\n@keyframes mobileBounce {\n  0% {\n    margin-left: 0;\n  }\n  50% {\n    margin-left: -30vw;\n  }\n  100% {\n    margin-left: 0;\n  }\n}\n.app__content {\n  position: relative;\n  top: 0;\n  width: 100%;\n  text-align: center;\n}\n\nbutton {\n  border-radius: 3px;\n  border: none;\n  padding: 10px 20px;\n  cursor: pointer;\n  display: block;\n}\nbutton a {\n  color: #fff;\n  text-decoration: none;\n}\nbutton.red {\n  background-color: #9D0208;\n  color: #fff;\n  transition: 0.2s ease-out all;\n}\nbutton.red:hover {\n  background-color: #6b0105;\n}\nbutton.orange {\n  background-color: #F48C06;\n  color: #fff;\n  transition: 0.2s ease-out all;\n}\n\n.disabled {\n  pointer-events: none;\n}\n\n.close-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n  font-size: 18px;\n  display: inline-block;\n  vertical-align: top;\n}\n\n.cookies {\n  position: fixed;\n  padding: 20px;\n  background: rgba(0, 0, 0, 0.9);\n  color: #fff;\n  z-index: 3;\n  width: 100vw;\n  left: 0;\n  bottom: 0;\n  text-align: center;\n  display: none;\n}\n.cookies__buttons {\n  display: inline-block;\n  margin-left: 20px;\n}\n@media (max-width: 974px) {\n  .cookies__buttons {\n    margin-top: 15px;\n  }\n}\n.cookies__buttons button {\n  display: inline-block;\n  margin: 0 10px;\n}\n.cookies__copy {\n  margin-bottom: 20px;\n  margin: auto;\n  display: inline-block;\n  vertical-align: bottom;\n  width: 100%;\n  max-width: 400px;\n  text-align: left;\n  font-size: 14px;\n  font-weight: 200;\n}\n\n.carousel {\n  position: relative;\n  overflow: hidden;\n  background-image: url(\"../images/carousel_bg.svg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  padding-top: 90px;\n  height: 100%;\n  z-index: 0;\n  pointer-events: none;\n}\n.carousel__hands {\n  position: absolute;\n  top: 5vw;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  background-image: url(\"../images/zombie_hands.svg\");\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: top;\n  filter: drop-shadow(5px -5px 10px rgba(0, 0, 0, 0.4));\n  pointer-events: none;\n  background-position: center;\n}\n@media (max-width: 974px) {\n  .carousel__hands {\n    background-image: url(\"../images/zombie_hands_mobile.svg\");\n    background-size: 145%;\n  }\n}\n.carousel__items {\n  position: absolute;\n  margin: 0 auto;\n  left: 5%;\n  width: 90%;\n  height: 85%;\n  background-color: #000;\n  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.4);\n}\n@media (min-width: 975px) and (max-width: 1799px) {\n  .carousel__items {\n    width: 90%;\n    height: 82%;\n  }\n}\n@media (max-width: 974px) {\n  .carousel__items {\n    width: 95%;\n    height: 98.5%;\n    left: 2.5%;\n    top: env(safe-area-inset-bottom);\n    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.4);\n  }\n}\n.carousel__items .carousel__item {\n  width: 100%;\n  height: 100%;\n  margin: auto;\n}\n.carousel__items .carousel__item__copy {\n  position: absolute;\n  z-index: 2;\n  text-align: center;\n  font-size: 56px;\n  line-height: 52px;\n  font-family: \"Museum Drip\", sans-serif;\n  bottom: calc(13% + 40px);\n  width: 80%;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n@media (max-width: 974px) {\n  .carousel__items .carousel__item__copy {\n    display: block;\n    font-size: 36px;\n    line-height: 32px;\n    bottom: calc(17% + 10px);\n  }\n}\n.carousel__items .carousel__item__copy a {\n  color: unset;\n  text-decoration: none;\n  transition: 0.3s ease-out all;\n  pointer-events: all;\n}\n.carousel__items .carousel__item__copy a:hover {\n  text-decoration: underline;\n}\n.carousel__items .carousel__item img, .carousel__items .carousel__item video {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.carousel .item-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  overflow: hidden;\n  opacity: 0;\n}\n.carousel .item-container.fadeIn {\n  opacity: 1;\n  transition: opacity 2s ease-out;\n}\n.carousel .item-container.fadeOut {\n  opacity: 0;\n  transition: opacity 0.3s ease-out;\n}\n.carousel .carousel__item {\n  left: 0 !important;\n  z-index: -1;\n}\n.carousel .arrow-container {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 50px;\n  text-align: center;\n  bottom: -5px;\n}\n@media (min-width: 975px) and (max-width: 1799px) {\n  .carousel .arrow-container {\n    transform: scale(0.8);\n    transform-origin: left;\n    margin-left: -2%;\n  }\n}\n@media (max-width: 974px) {\n  .carousel .arrow-container {\n    bottom: calc(env(safe-area-inset-bottom) - 5px);\n    transform: scale(0.65);\n    transform-origin: left;\n    margin-left: -4%;\n  }\n}\n.carousel .arrow-container .skull {\n  position: absolute;\n  width: 50px;\n  left: -4px;\n  animation: bounce 1s infinite alternate;\n  animation-delay: 0.3s;\n}\n.carousel .arrow-container .skull img {\n  position: relative;\n  top: -100px;\n  width: 100%;\n  height: auto;\n}\n.carousel .arrow-container .down-arrow {\n  position: relative;\n  animation: bounce 1s infinite ease-in-out;\n}\n.carousel .arrow-container .down-arrow img {\n  width: 36px;\n  height: auto;\n}\n\n.cart {\n  position: fixed;\n  right: 0;\n  height: 100vh;\n  width: 25vw;\n  background-color: #000;\n  z-index: 3;\n  padding: 40px;\n  color: #FFF;\n}\n.cart__title {\n  position: absolute;\n  top: 10px;\n  font-size: 44px;\n}\n.cart__total {\n  position: absolute;\n  bottom: 40px;\n}\n.cart__products {\n  margin-top: 60px;\n}\n.cart__products .cart__product {\n  position: relative;\n  margin-top: 20px;\n}\n.cart__products .cart__product__details {\n  font-size: 12px;\n}\n.cart__products .cart__product__details__title {\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n.cart__products .cart__product__details__quantity .minus, .cart__products .cart__product__details__quantity .plus {\n  cursor: pointer;\n  font-size: 30px;\n  display: inline-block;\n  margin: 10px 5px;\n}\n.cart.active {\n  display: block;\n}\n\n.footer {\n  position: relative;\n  width: 100%;\n  padding: 10px 0 20px 0;\n  background-color: #9D0208;\n  color: #FFF;\n  text-align: center;\n  font-size: 12px;\n  z-index: 2;\n  transform: translateZ(100px);\n}\n.footer:before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 18px;\n  background-image: url(\"../images/drip_footer.svg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  left: 0;\n  top: -18px;\n}\n.footer__content {\n  position: relative;\n  z-index: 1;\n}\n.footer__email {\n  margin-top: 10px;\n  font-size: 20px;\n  font-family: \"Museum Drip\", sans-serif;\n  transition: 0.3s ease-out all;\n}\n.footer__email a {\n  color: #fff;\n  text-decoration: none;\n}\n.footer__email a:hover {\n  text-decoration: underline;\n}\n.footer__social {\n  vertical-align: middle;\n  position: relative;\n  left: 0;\n}\n.footer__social ul {\n  margin: 0;\n  padding: 0;\n}\n.footer__social li {\n  list-style: none;\n  display: inline-block;\n  font-size: 20px;\n  margin: 0 10px;\n  cursor: pointer;\n}\n.footer__social li a {\n  color: #fff;\n}\n.footer__legal {\n  display: inline-block;\n  vertical-align: middle;\n  margin-top: 5px;\n}\n.footer__drip {\n  position: absolute;\n  width: 100%;\n  height: 20px;\n  top: -18px;\n  left: 0;\n  z-index: 1;\n}\n.footer__drip img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.nav {\n  position: fixed;\n  z-index: 3;\n  display: inline-block;\n  width: 100%;\n  height: 90px;\n  padding: 20px 0;\n  background-color: #000;\n  transition: all 0.3s ease-out;\n}\n.nav.intro {\n  background-color: #9D0208;\n  transition: 1s all ease-out;\n}\n.nav__cart {\n  position: absolute;\n  top: 30px;\n  right: 20px;\n  z-index: 3;\n  cursor: pointer;\n  color: #FFF;\n  font-size: 25px;\n  transition: all 0.3s ease-out;\n}\n.nav__cart:hover {\n  color: #F48C06;\n}\n.nav__cart:hover .nav__cart__count {\n  color: #F48C06;\n}\n.nav__cart__count {\n  position: absolute;\n  margin-top: -20px;\n  margin-left: 2px;\n  font-size: 20px;\n  color: #FFF;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  font-family: \"Museum Drip\", sans-serif;\n  transition: all 0.3s ease-out;\n}\n.nav__cart__count.added {\n  animation: bounce 1s infinite alternate;\n}\n@media (max-width: 974px) {\n  .nav__cart {\n    transform: scale(0.9);\n  }\n}\n.nav__background {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  background-color: #000;\n  transform-origin: top;\n  animation-name: shrink;\n  animation-duration: 0.3s;\n  animation-timing-function: ease-in;\n  animation-fill-mode: forwards;\n  animation-delay: 0.65s;\n  z-index: -1;\n}\n.nav__logo {\n  position: relative;\n  left: 20px;\n  z-index: 3;\n  width: 300px;\n  height: auto;\n  animation: 1s ease-out 1.5s forwards flicker;\n  cursor: pointer;\n  transition: all 0.3s ease-out;\n  margin: auto;\n}\n@media (max-width: 974px) {\n  .nav__logo {\n    width: 250px;\n    left: 0;\n  }\n}\n.nav__logo.intro {\n  opacity: 0.2;\n}\n.nav__logo__left {\n  width: 100px;\n  display: inline-block;\n}\n.nav__logo.flicker-loop {\n  animation: 1s ease-out forwards flicker-loop;\n}\n.nav__drip {\n  position: absolute;\n  height: 30px;\n  bottom: -28px;\n  width: 100%;\n  left: 0;\n  z-index: 1;\n  filter: brightness(0) drop-shadow(5px -5px 10px rgba(0, 0, 0, 0.8));\n}\n.nav__drip img {\n  width: 100%;\n  animation-name: grow;\n  animation-duration: 3.8s;\n  animation-timing-function: cubic-bezier(0.1, 0.58, 1);\n  animation-fill-mode: forwards;\n  transform-origin: top;\n  transform: scaleY(0);\n  animation-delay: 1.1s;\n}\n@media (max-width: 974px) {\n  .nav__drip img {\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.shop {\n  position: relative;\n  display: block;\n  z-index: 2;\n  margin-top: -80px;\n  filter: drop-shadow(10px 10px 30px rgba(0, 0, 0, 0.4));\n}\n@media (max-width: 974px) {\n  .shop {\n    margin-top: -120px;\n  }\n}\n.shop__title {\n  position: absolute;\n  top: calc(-30px - 1vw);\n  right: 5vw;\n  transform: rotate(-1deg);\n}\n@media (max-width: 974px) {\n  .shop__title {\n    top: calc(-22px - 1vw);\n  }\n}\n.shop__background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  background-color: #000;\n  clip-path: polygon(0 3%, 100% 0, 100% 97%, 0 100%);\n  opacity: 0.9;\n}\n@media (max-width: 974px) {\n  .shop__background {\n    clip-path: polygon(0 1%, 100% 0, 100% 99%, 0 100%);\n  }\n}\n.shop__background:before {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  background-image: url(\"../images/stars_bg.png\");\n  background-size: contain;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  opacity: 0.6;\n  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.4);\n}\n.shop__products {\n  position: relative;\n  max-width: 95vw;\n  margin: auto;\n  text-align: center;\n  z-index: 1;\n  padding: 100px 0;\n}\n.shop__products__legal {\n  font-size: 12px;\n  color: #999;\n  position: relative;\n  top: 20px;\n  width: 40%;\n  font-weight: 200;\n  display: block;\n  margin: auto;\n}\n.shop__products__legal a {\n  color: #999;\n}\n.shop__products__legal a:hover {\n  text-decoration: none;\n}\n@media (max-width: 974px) {\n  .shop__products__legal {\n    width: 90%;\n    bottom: 40px;\n  }\n}\n@media (max-width: 974px) {\n  .shop__products {\n    padding-top: 70px;\n  }\n}\n.shop__products .product {\n  position: relative;\n  width: 40vw;\n  max-width: 200px;\n  margin: 10px;\n  display: inline-block;\n  vertical-align: top;\n}\n@media (min-width: 975px) and (max-width: 1799px) {\n  .shop__products .product {\n    margin: 20px 40px;\n  }\n}\n.shop__products .product .product-details__images {\n  position: relative;\n  margin: 20px 0 10px 0;\n}\n@media (max-width: 974px) {\n  .shop__products .product .product-details__images {\n    margin: 0;\n  }\n}\n.shop__products .product .product-details__images__image {\n  position: relative;\n  width: 100%;\n  height: 200px;\n  margin: 20px 0;\n}\n@media (max-width: 974px) {\n  .shop__products .product .product-details__images__image {\n    height: 160px;\n  }\n}\n.shop__products .product .product-details__images__image:hover .enlarge {\n  display: block;\n}\n.shop__products .product .product-details .description {\n  margin-bottom: 10px;\n}\n.shop__products .product .product-details .enlarge {\n  position: absolute;\n  top: 0;\n  right: 10px;\n  cursor: pointer;\n  z-index: 1;\n  display: none;\n}\n.shop__products .product .product-details .enlarge a {\n  color: #fff;\n}\n.shop__products .product h3 {\n  color: #fff;\n  font-weight: 400;\n  font-size: 18px;\n}\n@media (max-width: 974px) {\n  .shop__products .product h3 {\n    font-size: 14px;\n  }\n}\n.shop__products .product img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  object-position: center;\n  position: absolute;\n  left: 0;\n  opacity: 0;\n}\n.shop__products .product img.active {\n  opacity: 1;\n}\n.shop__products .product p {\n  color: #fff;\n  font-size: 16px;\n}\n.shop__products .product p.price {\n  margin: 5px 0;\n  font-size: 14px;\n  font-weight: 300;\n}\n.shop__products .product p.description {\n  font-weight: 200;\n  font-size: 14px;\n}\n@media (max-width: 974px) {\n  .shop__products .product p.description {\n    font-size: 12px;\n  }\n}\n.shop__products .product select {\n  display: block;\n  margin: auto;\n  width: 50%;\n  background-color: #000;\n  color: #fff;\n  padding: 10px;\n  font-size: 14px;\n  border-radius: 3px;\n  border: 2px solid #333;\n}\n@media (max-width: 974px) {\n  .shop__products .product select {\n    width: 80%;\n  }\n}\n.shop__products .product .add-to-cart {\n  display: block;\n  margin: 15px auto;\n  width: 70%;\n  font-size: 14px;\n}\n@media (max-width: 974px) {\n  .shop__products .product .add-to-cart {\n    width: 80%;\n  }\n}\n\n.news {\n  position: relative;\n  z-index: 1;\n  text-align: left;\n  filter: drop-shadow(0px -2px 5px rgba(0, 0, 0, 0.4));\n  margin-top: 10px;\n  vertical-align: bottom;\n}\n.news__title {\n  position: absolute;\n  rotate: 2deg;\n  top: 10px;\n  right: 5vw;\n  color: #9D0208;\n  z-index: 1;\n}\n@media (max-width: 974px) {\n  .news__title {\n    top: -16px;\n  }\n}\n.news__background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  background-image: url(\"../images/news_bg.jpg\");\n  background-size: cover;\n  background-position: center;\n  clip-path: polygon(0 0, 100% 8%, 100% 100%, 0 100%);\n}\n@media (max-width: 974px) {\n  .news__background {\n    clip-path: polygon(0 1%, 100% 2%, 100% 100%, 0 100%);\n  }\n}\n.news__list {\n  position: relative;\n  padding: 5vw 0 12vw 0;\n  outline: none;\n  height: 80vh;\n  overflow: hidden;\n}\n@media (max-width: 974px) {\n  .news__list {\n    height: unset;\n  }\n}\n.news__list__item {\n  position: relative;\n  width: 100%;\n  padding: 0 8%;\n  color: #fff;\n  display: inline-block;\n  text-align: center;\n}\n@media (max-width: 974px) {\n  .news__list__item {\n    min-height: 60vh;\n  }\n}\n.news__list__item:first-child {\n  display: block;\n}\n.news__list__item__image {\n  position: relative;\n  display: inline-block;\n  max-width: calc(50% - 20px);\n  margin-right: 20px;\n  vertical-align: top;\n  height: 100%;\n}\n@media (max-width: 974px) {\n  .news__list__item__image {\n    width: 90%;\n    margin: 0 0 20px 0;\n    max-width: none;\n    padding-top: 60px;\n  }\n}\n.news__list__item__image img {\n  width: 100%;\n  height: 100%;\n  max-height: calc(65vh - 20px);\n}\n.news__list__item__text {\n  display: inline-block;\n  width: calc(42% - 20px);\n  vertical-align: top;\n  margin: auto;\n  text-align: left;\n}\n.news__list__item__text.no-image {\n  width: unset;\n  padding-top: 20vh;\n}\n.news__list__item__text h1, .news__list__item__text h2, .news__list__item__text h3, .news__list__item__text h4, .news__list__item__text h5, .news__list__item__text h6 {\n  font-family: \"Capitals Serif Rough\";\n  font-size: 30px;\n  color: #fff;\n}\n@media (max-width: 974px) {\n  .news__list__item__text h1, .news__list__item__text h2, .news__list__item__text h3, .news__list__item__text h4, .news__list__item__text h5, .news__list__item__text h6 {\n    font-size: 20px;\n  }\n}\n.news__list__item__text__date {\n  font-weight: 200;\n  font-size: 14px;\n  margin: 0 0 20px 0 !important;\n}\n.news__list__item__text__title {\n  font-family: \"Capitals Serif Rough\";\n  font-size: 30px;\n  margin-bottom: 20px;\n}\n.news__list__item__text__copy p {\n  margin: 0 0 15px 0;\n}\n.news__list__item__text__copy a {\n  color: #FFF;\n  text-decoration: underline;\n}\n@media (max-width: 974px) {\n  .news__list__item__text {\n    width: 90%;\n    padding-left: 0;\n  }\n}\n.news__list .flickity-viewport {\n  overflow: visible;\n}\n.news__list.bounce-loop .flickity-slider {\n  animation: mobileBounce 1s ease-in-out forwards;\n}\n.news__list .flickity-button {\n  position: absolute;\n  background: none;\n}\n.news__list .flickity-button:before {\n  content: \"\";\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  background-image: url(\"../images/skull_arrow.png\");\n  background-size: cover;\n  transform: scale(1);\n  animation: topBounce 2s infinite alternate;\n  margin-top: 15px;\n}\n.news__list .flickity-button:after {\n  position: absolute;\n  right: 1%;\n  width: 75px;\n  height: 180px;\n  content: \"\";\n  background-image: url(\"../images/bone_arrow.png\");\n  transform: rotate(-90deg) scale(0.35);\n}\n@media (max-width: 974px) {\n  .news__list .flickity-button {\n    display: none;\n  }\n}\n.news__list .flickity-button svg {\n  display: none;\n}\n.news__list .flickity-button.previous {\n  left: 5px;\n}\n.news__list .flickity-button.previous:disabled {\n  display: none;\n}\n.news__list .flickity-button.previous:after {\n  transform: rotate(90deg) scale(0.4);\n  animation: arrowBouncePrevious 1s infinite;\n}\n.news__list .flickity-button.next {\n  right: 5px;\n}\n.news__list .flickity-button.next:disabled {\n  display: none;\n}\n.news__list .flickity-button.next:before {\n  right: 30px;\n}\n.news__list .flickity-button.next:after {\n  animation: arrowBounceNext 1s infinite;\n}\n\n.videos {\n  position: relative;\n  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.4);\n  z-index: -1;\n  margin-top: 170px;\n}\n@media (max-width: 974px) {\n  .videos {\n    margin-top: 150px;\n  }\n}\n.videos__title {\n  position: absolute;\n  top: -50px;\n  left: 5vw;\n  z-index: 1;\n}\n@media (max-width: 974px) {\n  .videos__title {\n    top: -30px;\n  }\n}\n.videos__item {\n  position: relative;\n  width: 33.3333333333%;\n  padding-bottom: 22%;\n  display: inline-block;\n  cursor: pointer;\n  background-size: cover;\n  margin: 0;\n  vertical-align: top;\n}\n.videos__item:before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  opacity: 0;\n  left: 0;\n  transition: 0.3s ease-out opacity;\n}\n.videos__item:hover:before {\n  opacity: 1;\n}\n@media (max-width: 974px) {\n  .videos__item {\n    width: 100%;\n    padding-bottom: 68%;\n  }\n}\n.videos__item__title {\n  position: absolute;\n  font-size: 42px;\n  color: #FFF;\n  text-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  bottom: 40px;\n  z-index: 2;\n}\n.videos__item:after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100px;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5032606793) 0%, rgba(0, 0, 0, 0.2987788866) 38%, rgba(0, 0, 0, 0) 100%);\n}\n\n.legal {\n  background-color: #000;\n  padding: 40px;\n  color: #FFF;\n  font-family: sans-serif;\n  min-height: 100vh;\n  font-size: 14px;\n}\n.legal p {\n  margin: 20px 0;\n}\n.legal a {\n  color: #FFF;\n  text-decoration: underline;\n}\n.legal a:hover {\n  color: #F48C06;\n}",".app {\n  &__content {\n    position: relative;\n    top: 0;\n    width: 100%;\n    text-align: center;\n    // padding-top: 90px;\n  }\n}","button {\n  border-radius: 3px;\n  border: none;\n  padding: 10px 20px;\n  cursor: pointer;\n  display: block;\n\n  a {\n    color: #fff;\n    text-decoration: none;\n  }\n\n  &.red {\n    background-color: map-get($theme, red);\n    color: #fff;\n    transition: .2s ease-out all;\n\n    &:hover {\n      background-color: darken(map-get($theme, red), 10%);\n    }\n  }\n\n  &.orange {\n    background-color: map-get($theme, orange);\n    color: #fff;\n    transition: .2s ease-out all;\n  }\n}\n\n.disabled {\n  pointer-events: none;\n}\n\n.close-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  @include button;\n  font-size: 18px;\n  display: inline-block;\n  vertical-align: top;\n}\n\n.cookies {\n  position: fixed;\n  padding: 20px;\n  background: rgba(0,0,0,0.9);\n  color: #fff;\n  z-index: 3;\n  width: 100vw;\n  left: 0;\n  bottom: 0;\n  text-align: center;\n  display: none;\n\n  &__buttons {\n    display: inline-block;\n    margin-left: 20px;\n\n    @include for-size(phone-only) {\n      margin-top: 15px;\n    }\n\n    button {\n      display: inline-block;\n      margin: 0 10px;\n    }\n  }\n\n  &__copy {\n    margin-bottom: 20px;\n    margin:auto;\n    display: inline-block;\n    vertical-align: bottom;\n    width: 100%;\n    max-width: 400px;\n    text-align: left;\n    font-size: 14px;\n    font-weight: 200;\n  }\n}",".carousel {\n  position: relative;\n  overflow: hidden;\n  background-image: url('../images/carousel_bg.svg');\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  padding-top: 90px;\n  height: 100%;\n  z-index: 0;\n  pointer-events: none;\n\n  &__hands {\n    position: absolute;\n    top: 5vw;\n    width: 100%;\n    height: 100%;\n    z-index: 0;\n    background-image: url('../images/zombie_hands.svg');\n    background-size: 100%;\n    background-repeat: no-repeat;\n    background-position: top;\n    filter: drop-shadow(5px -5px 10px rgba(0,0,0,0.4));\n    pointer-events: none;\n    background-position: center;\n\n    @include for-size(phone-only) {\n      background-image: url('../images/zombie_hands_mobile.svg');\n      background-size: 145%;\n    }\n\n  }\n  &__items {\n    position: absolute;\n    margin: 0 auto;\n    left: 5%;\n    width: 90%;\n    height: 85%;\n    background-color: #000;\n    @include boxShadow;\n\n    @include for-size(small-desktop) {\n      width: 90%;\n      height: 82%;\n    }\n\n    @include for-size(phone-only) {\n      width: 95%;\n      height: 98.5%;\n      left: 2.5%;\n      top: env(safe-area-inset-bottom);\n      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.4);\n    }\n\n    .carousel__item {\n      width: 100%;\n      height: 100%;\n      margin: auto;\n\n      &__copy {\n        position: absolute;\n        z-index: 2;\n        text-align: center;\n        font-size: 56px;\n        line-height: 52px;\n        font-family: \"Museum Drip\", sans-serif;\n        bottom: calc(13% + 40px);\n        width: 80%;\n        @include horzCenter;\n\n        @include for-size(phone-only) {\n          display: block;\n          font-size: 36px;\n          line-height: 32px;\n          bottom: calc(17% + 10px);\n        }\n\n        a {\n          color: unset;\n          text-decoration: none;\n          transition: .3s ease-out all;\n          pointer-events: all;\n\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n      \n      img, video {\n        display: block;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n\n  .item-container {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    overflow: hidden;\n    opacity: 0;\n\n    &.fadeIn {\n      opacity: 1;\n      transition: opacity 2s ease-out;\n    }\n\n    &.fadeOut {\n      opacity: 0;\n      transition: opacity .3s ease-out;\n    }\n  }\n\n  .carousel__item {\n    left: 0 !important;\n    z-index: -1;\n  }\n\n  .arrow-container {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 50px;\n    text-align: center;\n    bottom: -5px;\n\n    @include for-size(small-desktop) {\n      transform: scale(0.8);\n      transform-origin: left;\n      margin-left: -2%;\n    }\n    \n  \n    @include for-size(phone-only) {\n      bottom: calc(env(safe-area-inset-bottom) - 5px);\n      transform: scale(0.65);\n      transform-origin: left;\n      margin-left: -4%;\n    }\n  \n    .skull {\n      position: absolute;\n      width: 50px;\n      left: -4px;\n      animation: bounce 1s infinite alternate;\n      animation-delay: .3s;\n  \n      img {\n        position: relative;\n        top: -100px;\n        width: 100%;\n        height: auto;\n      }\n    }\n    .down-arrow {\n      position: relative;\n      animation: bounce 1s infinite ease-in-out;\n    \n      img {\n        width: 36px;\n        height: auto;\n      }\n    }\n  }\n}",".cart {\n  position: fixed;\n  right: 0;\n  height: 100vh;\n  width: 25vw;\n  background-color: #000;\n  z-index: 3;\n  padding: 40px;\n  color: #FFF;\n\n  &__title {\n    position:absolute;\n    top: 10px;\n    font-size: 44px;\n  }\n\n  &__total {\n    position: absolute;\n    bottom: 40px;\n  }\n\n  &__products {\n    margin-top: 60px;\n\n    .cart__product {\n      position: relative;\n      margin-top: 20px;\n      &__details {\n        &__title {\n          font-size: 16px;\n          margin-bottom: 5px;\n        }\n        font-size: 12px;\n\n        &__quantity {\n          .minus, .plus {\n            cursor: pointer;\n            font-size: 30px;\n            display: inline-block;\n            margin: 10px 5px;\n          }\n        }\n      }\n    }\n  }\n\n  &.active {\n    display: block;\n  }\n}",".footer {\n  position: relative;\n  width: 100%;\n  padding: 10px 0 20px 0;\n  background-color: map-get($theme, red);\n  color: map-get($theme, white);\n  text-align: center;\n  font-size: 12px;\n  z-index: 2;\n  transform: translateZ(100px);\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 18px;\n    background-image:url('../images/drip_footer.svg');\n    background-size: cover;\n    background-repeat: no-repeat;\n    left: 0;\n    top: -18px;\n  }\n  &__content {\n    position: relative;\n    z-index: 1;\n  }\n\n  &__email {\n    margin-top: 10px;\n    font-size: 20px;\n    font-family: \"Museum Drip\", sans-serif;\n    transition: .3s ease-out all;\n    a {\n      color: #fff;\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n\n  &__social {\n    vertical-align: middle;\n    position: relative;\n    left: 0;\n    ul {\n      margin: 0;\n      padding: 0;\n    }\n    li {\n      list-style: none;\n      display: inline-block;\n      font-size: 20px;\n      margin: 0 10px;\n      cursor: pointer;\n\n      a {\n        color: #fff;\n      }\n    }\n  }\n  &__legal {\n    display: inline-block;\n    vertical-align: middle;\n    margin-top: 5px;\n  }\n  &__drip {\n    position: absolute;\n    width: 100%;\n    height: 20px;\n    top: -18px;\n    left: 0;\n    z-index: 1;\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n}",".nav {\n  position: fixed;\n  z-index: 3;\n  display: inline-block;\n  width: 100%;\n  height: 90px;\n  padding: 20px 0;\n  background-color: map-get($theme, black);\n  transition: all .3s ease-out;\n\n  &.intro {\n    background-color: map-get($theme, red);\n    transition: 1s all ease-out;\n  }\n\n  &__cart {\n    position: absolute;\n    top: 30px;\n    right: 20px;\n    z-index: 3;\n    cursor: pointer;\n    color: #FFF;\n    font-size: 25px;\n    transition: all .3s ease-out;\n\n    &:hover {\n      color: map-get($theme, orange);\n\n      .nav__cart__count {\n        color: map-get($theme, orange);\n      }\n    }\n\n    &__count {\n      position: absolute;\n      margin-top: -20px;\n      margin-left: 2px;\n      font-size: 20px;\n      color:#FFF;\n      @include horzCenter;\n      font-family: 'Museum Drip', sans-serif;\n      transition: all .3s ease-out;\n\n      &.added {\n        animation: bounce 1s infinite alternate;\n      }\n    }\n\n    @include for-size(phone-only) {\n      transform: scale(.9);\n    }\n  }\n\n  &__background {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    background-color: map-get($theme, black);\n    transform-origin: top;\n    animation-name: shrink;\n    animation-duration: .3s;\n    animation-timing-function: ease-in;\n    animation-fill-mode: forwards;\n    animation-delay: .65s;\n    z-index: -1;\n  }\n\n  &__logo {\n    position: relative;\n    left: 20px;\n    z-index: 3;\n    width: 300px;\n    height: auto;\n    animation: 1s ease-out 1.5s forwards flicker;\n    cursor: pointer;\n    transition: all .3s ease-out;\n    margin: auto;\n    \n    @include for-size(phone-only) {\n      width: 250px;\n      left: 0;\n    }\n\n    &.intro {\n      opacity: .2;\n    }\n\n    &__left {\n      width: 100px;\n      display: inline-block;\n    }\n\n    &.flicker-loop {\n      animation: 1s ease-out forwards flicker-loop;\n    }\n  }\n\n  &__drip {\n    position: absolute;\n    height: 30px;\n    bottom: -28px;\n    width: 100%;\n    left: 0;\n    z-index: 1;\n    filter: brightness(0) drop-shadow(5px -5px 10px rgba(0,0,0,0.8));\n\n    img {\n      width: 100%;\n      animation-name: grow;\n      animation-duration: 3.8s;\n      animation-timing-function: cubic-bezier(.1,.58,1);\n      animation-fill-mode: forwards;\n      transform-origin: top;\n      transform: scaleY(0);\n      animation-delay: 1.1s;\n\n      @include for-size(phone-only) {\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n}\n",".shop {\n  position: relative;\n  display: block;\n  z-index: 2;\n  margin-top: -80px;\n  filter: drop-shadow(10px 10px 30px rgba(0, 0, 0, 0.4));\n\n  @include for-size(phone-only) {\n    margin-top: -120px;\n  }\n\n  &__title {\n    position: absolute;\n    top: calc(-30px - 1vw);\n    right: 5vw;\n    transform: rotate(-1deg);\n\n    @include for-size(phone-only) {\n      top: calc(-22px - 1vw);\n    }\n  }\n\n  &__background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n    background-color: #000;\n    clip-path: polygon(0 3%, 100% 0, 100% 97%, 0 100%);\n\n    @include for-size(phone-only) {\n      clip-path: polygon(0 1%, 100% 0, 100% 99%, 0 100%);\n    }\n    opacity: 0.9;\n\n    &:before {\n      position: absolute;\n      content: \"\";\n      left: 0;\n      background-image:url('../images/stars_bg.png');\n      background-size: contain;\n      z-index: -1;\n      width: 100%;\n      height: 100%;\n      opacity: 0.6;\n      @include boxShadow;\n    }\n  }\n\n  &__products {\n    position: relative;\n    max-width: 95vw;\n    margin: auto;\n    text-align: center;\n    z-index: 1;\n    padding: 100px 0;\n\n    &__legal{\n      font-size: 12px;\n      color:#999;\n      position: relative;\n      top: 20px;\n      width: 40%;\n      font-weight: 200;\n      display: block;\n      margin: auto;\n\n      a {\n        color: #999;\n\n        &:hover {\n          text-decoration: none;\n        }\n      }\n\n      @include for-size(phone-only) {\n        width: 90%;\n        bottom: 40px;\n      }\n    }\n\n    @include for-size(phone-only) {\n      padding-top: 70px;\n    }\n\n    .product {\n      position: relative;\n      width: 40vw;\n      max-width: 200px;\n      margin: 10px;\n      display: inline-block;\n      vertical-align: top;\n\n      @include for-size(small-desktop) {\n        margin: 20px 40px;\n      }\n\n      .product-details {\n        &__images {\n          position: relative;\n          margin: 20px 0 10px 0;\n\n          @include for-size(phone-only) {\n            margin: 0;\n          }\n\n          &__image {\n            position: relative;\n            width: 100%;\n            height: 200px;\n            margin: 20px 0;\n\n            @include for-size(phone-only) {\n              height: 160px;\n            }\n\n            &:hover {\n              .enlarge {\n                display: block;\n              }\n            }\n          }\n        }\n\n        .description {\n          margin-bottom: 10px;\n        }\n\n        .enlarge {\n          position: absolute;\n          top: 0;\n          right: 10px;\n          cursor: pointer;\n          z-index: 1;\n          display: none;\n\n          a {\n            color: #fff;\n          }\n        }\n      }\n\n      h3 {\n        color: #fff;\n        font-weight: 400;\n        font-size: 18px;\n\n        @include for-size(phone-only) {\n          font-size: 14px;\n        }\n      }\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        object-position: center;\n        position: absolute;\n        left: 0;\n        opacity: 0;\n        &.active {\n          opacity: 1;\n        }\n      }\n      p {\n        color: #fff;\n        font-size: 16px;\n        &.price {\n          margin: 5px 0;\n          font-size: 14px;\n          font-weight: 300;\n        }\n        &.description {\n          font-weight: 200;\n          font-size: 14px;\n\n          @include for-size(phone-only) {\n            font-size: 12px;\n          }\n        }\n      }\n      select {\n        display: block;\n        margin: auto;\n        width: 50%;\n        background-color: #000;\n        color: #fff;\n        padding: 10px;\n        font-size: 14px;\n        border-radius: 3px;\n        border: 2px solid #333;\n\n        @include for-size(phone-only) {\n          width: 80%;\n        }\n      }\n\n      .add-to-cart {\n        display: block;\n        margin: 15px auto;\n        width: 70%;\n        font-size: 14px;\n\n        @include for-size(phone-only) {\n          width: 80%;\n        }\n      }\n    }\n  }\n}",".news {\n  position: relative;\n  z-index:1;\n  text-align: left;\n  filter: drop-shadow(0px -2px 5px rgba(0,0,0,0.4));\n  margin-top: 10px;\n  vertical-align: bottom;\n\n  &__title {\n    position: absolute;\n    rotate: 2deg;\n    top: 10px;\n    right: 5vw;\n    color: map-get($theme, red);\n    z-index: 1;\n\n    @include for-size(phone-only) {\n      top: -16px;\n    }\n  }\n\n  &__background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n    background-image: url('../images/news_bg.jpg');\n    background-size: cover;\n    background-position: center;\n    clip-path: polygon(0 0, 100% 8%, 100% 100%, 0 100%);\n    @include for-size(phone-only) {\n      clip-path: polygon(0 1%, 100% 2%, 100% 100%, 0 100%);\n    }\n  }\n\n  &__list {\n    position: relative;\n    padding: 5vw 0 12vw 0;\n    outline: none;\n    height: 80vh;\n    overflow: hidden;\n    @include for-size(phone-only) {\n      height: unset;\n    }\n\n    &__item {\n      position: relative;\n      width: 100%;\n      padding: 0 8%;\n      color:#fff;\n      display: inline-block;\n      text-align: center;\n      @include for-size(phone-only) {\n        min-height: 60vh;\n      }\n      \n      &:first-child {\n        display: block;\n      }\n      &__image {\n        position: relative;\n        display: inline-block;\n        max-width: calc(50% - 20px);\n        margin-right: 20px;\n        vertical-align: top;\n        height: 100%;\n\n        @include for-size(phone-only) {\n          width: 90%;\n          margin: 0 0 20px 0;\n          max-width: none;\n          padding-top: 60px;\n        }\n        img {\n          width: 100%;\n          height: 100%;\n          max-height: calc(65vh - 20px);\n        }\n      }\n      &__text {\n        display: inline-block;\n        width: calc(50% - 8% - 20px);\n        vertical-align: top;\n        margin: auto;\n        text-align: left;\n\n        &.no-image {\n          width: unset;\n\n          padding-top: 20vh;\n        }\n\n        h1, h2, h3, h4, h5, h6 {\n          font-family: 'Capitals Serif Rough';\n          font-size: 30px;\n          color: #fff;\n\n          @include for-size(phone-only) {\n            font-size: 20px;\n          }\n        }\n\n        &__date {\n          font-weight: 200;\n          font-size: 14px;\n          margin: 0 0 20px 0 !important;\n        }\n\n        &__title {\n          font-family: 'Capitals Serif Rough';\n          font-size: 30px;\n          margin-bottom: 20px;\n        }\n\n        &__copy {\n          p {\n            margin: 0 0 15px 0;\n          }\n\n          a {\n            color: #FFF;\n            text-decoration: underline;\n          }\n        }\n\n        @include for-size(phone-only) {\n          width: 90%;\n          padding-left: 0;\n        }\n      }\n    }\n\n    .flickity-viewport {\n      overflow: visible;\n    }\n\n    &.bounce-loop {\n      .flickity-slider {\n        animation: mobileBounce 1s ease-in-out forwards;\n      }\n    }\n\n\n    .flickity-button {\n      position: absolute;\n      background: none;\n\n      &:before {\n        content: \"\";\n        position: absolute;\n        width: 40px;\n        height: 40px;\n        background-image:url('../images/skull_arrow.png');\n        background-size: cover;\n        transform: scale(1);\n        animation: topBounce 2s infinite alternate;\n        margin-top: 15px;\n      }\n\n      &:after {\n        position: absolute;\n        right: 1%;\n        width: 75px;\n        height: 180px;\n        content:\"\";\n        background-image: url('../images/bone_arrow.png');\n        transform: rotate(-90deg) scale(0.35);\n      }\n\n      @include for-size(phone-only) {\n        display: none;\n      }\n      svg {\n        display: none;\n      }\n      &.previous {\n        left: 5px;\n        &:disabled {\n          display: none;\n        }\n        &:after {\n          transform: rotate(90deg) scale(0.4);\n          animation: arrowBouncePrevious 1s infinite;\n        }\n      }\n      &.next {\n        right: 5px;\n        &:disabled {\n          display: none;\n        }\n        &:before {\n          right:30px;\n        }\n        &:after {\n          animation: arrowBounceNext 1s infinite;\n        }\n      }\n    }\n  }\n}",".videos {\n  position: relative;\n  @include boxShadow;\n  z-index: -1;\n  // if shop is enabled\n  // margin-top: -40px;\n  \n  // @include for-size(phone-only) {\n  //   margin-top: -60px;\n  // }\n\n  margin-top: 170px;\n\n  @include for-size(phone-only) {\n    margin-top: 150px;\n  }\n\n  &__title {\n    position: absolute;\n    top: -50px;\n    left: 5vw;\n    z-index: 1;\n\n    @include for-size(phone-only) {\n      top: -30px;\n    }\n  }\n  &__item {\n    position: relative;\n    width: calc(100% / 3);\n    padding-bottom: 22%;\n    display: inline-block;\n    @include button;\n    background-size: cover;\n    margin:0;\n    vertical-align:top;\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      background: rgba(0,0,0,0.6);\n      opacity: 0;\n      left: 0;\n      transition: .3s ease-out opacity;\n    }\n\n    &:hover {\n      &:before {\n        opacity: 1;\n      }\n    }\n\n    @include for-size(phone-only) {\n      width: 100%;\n      padding-bottom: 68%;\n    }\n\n    &__title {\n      position: absolute;\n      font-size: 42px;\n      color: #FFF;\n      text-shadow: 0 0 5px rgba(0,0,0,0.2);\n      @include horzCenter;\n      bottom: 40px;\n      z-index: 2;\n    }\n\n    &:after {\n      content: \"\";\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: 100px;\n      background: linear-gradient(0deg, rgba(0,0,0,0.5032606792717087) 0%, rgba(0,0,0,0.2987788865546218) 38%, rgba(0,0,0,0) 100%);\n    }\n  }\n}",".legal {\n  background-color: #000;\n  padding: 40px;\n  color: #FFF;\n  font-family: sans-serif;\n  min-height: 100vh;\n  font-size: 14px;\n\n  p {\n    margin: 20px 0;\n  }\n\n  a {\n    color:#FFF;\n    text-decoration: underline;\n\n    &:hover {\n      color: map-get($theme, orange);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
